import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function HomePage() {
  const navigate = useNavigate();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main id="main-content" role="main">
      {/* Hero Section */}
      <section className="hero" aria-labelledby="hero-title" style={{position: 'relative', overflow: 'hidden'}}>
        <div className="hero__background" style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 0}}>
          <img src="/images/social-recruiting-berlin.png" alt="Social Recruiting Berlin" style={{width: '100%', height: '100%', objectFit: 'cover', opacity: 0.5, filter: 'brightness(0.8)'}} />
          <div className="hero__overlay" style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'linear-gradient(135deg, rgba(163, 135, 193, 0.3) 0%, rgba(201, 177, 211, 0.3) 100%)'}}></div>
        </div>
        <div className="container" style={{position: 'relative', zIndex: 2}}>
          <div className="hero__content">
            <div className="hero__text">
              <h1 id="hero-title" className="hero__title">
                Social Recruiting Berlin:
                <span className="hero__highlight"> Die Top-Agentur für Mitarbeitergewinnung</span>
                {' '}in der Hauptstadt
              </h1>
              
              <p className="hero__subtitle">
                Qualifizierte Bewerber über Instagram, LinkedIn & TikTok.
                Seit 2009 erfolgreich in Berlin tätig.
              </p>

              <div className="hero__stats">
                <div className="stat">
                  <span className="stat__number">8-25€</span>
                  <span className="stat__label">pro Bewerbung</span>
                </div>
                <div className="stat">
                  <span className="stat__number">67%</span>
                  <span className="stat__label">Social Media Reichweite</span>
                </div>
                <div className="stat">
                  <span className="stat__number">15+</span>
                  <span className="stat__label">Jahre Erfahrung</span>
                </div>
              </div>

              <div className="hero__cta">
                <button className="btn btn--primary btn--large" data-open-consultation data-source="Hero CTA">
                  Kostenloses Erstgespräch
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="content-section" aria-labelledby="intro-title">
        <div className="container">
          <div className="section-header">
            <h2 id="intro-title" className="section-title">Was ist Social Recruiting und warum ist es 2025 unverzichtbar?</h2>
            <p className="section-subtitle">
              Social Recruiting revolutioniert die Personalgewinnung und ist zur wichtigsten Recruiting Strategie für Unternehmen in Berlin geworden. Erfahren Sie, wie unsere Social Recruiting Agentur die besten Talente für Ihr Unternehmen findet.
            </p>
          </div>

          <div className="content-grid">
            <div className="content-text">
              <p>
                <strong>Social Recruiting</strong> bezeichnet den strategischen Einsatz von Social Media zur Mitarbeitergewinnung. Als spezialisierte Social Recruiting Agentur in Berlin nutzen wir Plattformen wie LinkedIn, Instagram, Facebook und TikTok, um gezielt qualifizierte Bewerber anzusprechen. Im Gegensatz zu traditionellen Recruiting Agenturen setzen wir auf die Nutzung von Social Media, um dort Talente zu erreichen, wo sie sich täglich aufhalten – in sozialen Netzwerken.
              </p>

              <p>
                Die Bedeutung von Social Media Recruiting wächst kontinuierlich. Laut der ARD/ZDF-Onlinestudie 2025 nutzen 67% der Deutschen täglich Social Media Plattformen. Für Unternehmen bedeutet dies eine enorme Chance: Durch eine durchdachte Social Media Recruiting Strategie können sie schnell und effizient qualifizierte Fachkräfte finden und rekrutieren. Unsere Social Recruiting Agentur hat sich auf genau diese Herausforderung spezialisiert.
              </p>

              <div className="info-box">
                <h4>Warum Social Recruiting in Berlin besonders erfolgreich ist</h4>
                <p>
                  Berlin ist das Zentrum für Innovation und Start-ups in Deutschland. Der Fachkräftemangel ist hier besonders spürbar, was Social Recruiting zur idealen Lösung macht. Durch gezielt platzierte Recruiting Kampagnen auf Social Media Plattformen erreichen wir potenzielle Kandidaten, die über traditionelle Kanäle nicht erreichbar wären. Die Kombination aus Employer Branding und strategischer Social Media Ansprache macht den Erfolg aus.
                </p>
              </div>

              <h3>Die Vorteile von Social Recruiting gegenüber traditionellen Methoden</h3>
              <p>
                Social Recruiting ermöglicht eine völlig neue Form der Kandidatenansprache. Während traditionelle Recruiting Agenturen oft auf Jobbörsen und passive Bewerbungen setzen, nutzt unsere Social Recruiting Agentur Berlin innovative Wege zur aktiven Talentsuche. Durch maßgeschneiderte Social Recruiting Kampagnen sprechen wir gezielt die Zielgruppe an, die perfekt zur Unternehmenskultur passt.
              </p>

              <p>
                Der Recruiting Prozess wird durch Social Media nicht nur effizienter, sondern auch kostengünstiger. Mit Kosten von 8-25€ pro qualifizierter Bewerbung liegt Social Recruiting deutlich unter den Kosten traditioneller Personalvermittler, die oft 20% des Jahresgehalts berechnen. Gleichzeitig ermöglicht die Nutzung von Social Media eine authentische Darstellung der Arbeitgebermarke, was bei der ersten Kontaktaufnahme entscheidend ist.
              </p>

              <h3>Social Media als Game-Changer im Recruiting</h3>
              <p>
                Die verschiedenen Social Media Kanäle bieten unterschiedliche Möglichkeiten für erfolgreiches Social Recruiting. LinkedIn eignet sich perfekt für die Ansprache von Fachkräften und HR-Professionals, während Instagram besonders effektiv ist, um jüngere Talente zu erreichen. Facebook Recruiting kombiniert breite Reichweite mit präzisem Targeting, und TikTok ermöglicht kreative, virale Recruiting Maßnahmen für die Gen Z.
              </p>

              <p>
                Unsere Social Recruiting Agentur entwickelt für jede Plattform die passende Strategie. Wir wissen, dass beim Social Recruiting die richtige Balance zwischen Reichweite und Relevanz entscheidend ist. Durch datenbasierte Entscheidungen optimieren wir kontinuierlich die Performance Ihrer Recruiting Kampagne, um die besten Talente für Ihr Unternehmen zu gewinnen.
              </p>

              <div className="stats-grid">
                <div className="stat-box">
                  <span className="stat-box__number">67%</span>
                  <span className="stat-box__label">Social Media Nutzer in Deutschland</span>
                </div>
                <div className="stat-box">
                  <span className="stat-box__number">8-25€</span>
                  <span className="stat-box__label">Kosten pro Bewerbung</span>
                </div>
                <div className="stat-box">
                  <span className="stat-box__number">7-14 Tage</span>
                  <span className="stat-box__label">Zeit bis erste Bewerbungen</span>
                </div>
                <div className="stat-box">
                  <span className="stat-box__number">500+</span>
                  <span className="stat-box__label">Erfolgreiche Kampagnen</span>
                </div>
              </div>
            </div>

            <div className="content-sidebar">
              <div className="sidebar-widget">
                <h3>Quick Facts: Social Recruiting</h3>
                <ul>
                  <li>Aktive Kandidatenansprache statt passive Stellenanzeigen</li>
                  <li>Gezieltes Targeting nach Skills und Interessen</li>
                  <li>Authentische Darstellung der Arbeitgebermarke</li>
                  <li>Messbare Ergebnisse in Echtzeit</li>
                  <li>Zugang zu passiven Kandidaten</li>
                  <li>Kosteneffizienter als traditionelle Methoden</li>
                </ul>
              </div>

              <div className="sidebar-widget">
                <h3>Unsere Expertise</h3>
                <p>
                  Als führende Social Recruiting Agentur in Berlin vereinen wir über 15 Jahre Erfahrung im Bereich Social Media Marketing mit tiefem HR-Know-how. Wir verstehen sowohl die technischen Aspekte der Plattformen als auch die strategischen Anforderungen erfolgreicher Personalgewinnung.
                </p>
              </div>

              <div className="sidebar-widget">
                <h3>Jetzt starten</h3>
                <p>
                  Lassen Sie uns gemeinsam die richtigen Menschen für Ihr Unternehmen finden. Vereinbaren Sie ein kostenloses Erstgespräch.
                </p>
                <button className="btn btn--primary btn--full" data-open-consultation data-source="Intro Sidebar CTA">
                  Kostenloses Erstgespräch
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Trust Indicators */}
      <section className="trust-indicators">
        <div className="container">
          <div className="trust-indicators__content">
            <div className="trust-indicators__logos">
              <img src="/images/clients/vattenfall-agentur.png" alt="Vattenfall" className="trust-logo" />
              <img src="/images/clients/rewe-agentur.png" alt="REWE" className="trust-logo" />
              <img src="/images/clients/casio-agentur.png" alt="Casio" className="trust-logo" />
              <img src="/images/clients/autohero-agentur.png" alt="AutoHero" className="trust-logo" />
            </div>
            <div className="trust-indicators__text">
              <p>Vertraut von führenden Unternehmen in Berlin und deutschlandweit</p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services" aria-labelledby="services-title">
        <div className="container">
          <div className="section-header">
            <h2 id="services-title" className="section-title">Social Recruiting Services in Berlin</h2>
            <p className="section-subtitle">
              Als führende Social Recruiting Agentur in Berlin bieten wir professionelle Mitarbeitergewinnung über alle relevanten Social Media Plattformen
            </p>
          </div>

          <div className="services__grid">
            <div className="service-card">
              <div className="service-card__icon">📸</div>
              <h3 className="service-card__title">Instagram Recruiting</h3>
              <p className="service-card__description">
                Erreichen Sie junge Talente und Fachkräfte über Instagram. 
                Authentische Inhalte für maximale Reichweite in Berlin.
              </p>
              <div className="service-card__features">
                <span className="feature-tag">Story Ads</span>
                <span className="feature-tag">Reels</span>
                <span className="feature-tag">Carousel Posts</span>
              </div>
              <button 
                className="btn btn--outline btn--full"
                onClick={() => navigate('/leistungen/instagram-recruiting')}
              >
                Mehr erfahren
              </button>
            </div>

            <div className="service-card">
              <div className="service-card__icon">💼</div>
              <h3 className="service-card__title">LinkedIn Recruiting</h3>
              <p className="service-card__description">
                Professionelle B2B-Personalgewinnung über LinkedIn. 
                Executive Search und Fachkräfte für Berliner Unternehmen.
              </p>
              <div className="service-card__features">
                <span className="feature-tag">Executive Search</span>
                <span className="feature-tag">InMail Kampagnen</span>
                <span className="feature-tag">Company Branding</span>
              </div>
              <button 
                className="btn btn--outline btn--full"
                onClick={() => navigate('/leistungen/linkedin-recruiting')}
              >
                Mehr erfahren
              </button>
            </div>

            <div className="service-card">
              <div className="service-card__icon">📱</div>
              <h3 className="service-card__title">TikTok Recruiting</h3>
              <p className="service-card__description">
                Gen Z und junge Talente über TikTok erreichen. 
                Kreative, virale Inhalte für maximale Sichtbarkeit in Berlin.
              </p>
              <div className="service-card__features">
                <span className="feature-tag">Short Videos</span>
                <span className="feature-tag">Challenges</span>
                <span className="feature-tag">Influencer Marketing</span>
              </div>
              <button 
                className="btn btn--outline btn--full"
                onClick={() => navigate('/leistungen/tiktok-recruiting')}
              >
                Mehr erfahren
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Comparison Section */}
      <section className="content-section" style={{background: '#f9fafb'}} aria-labelledby="comparison-title">
        <div className="container">
          <div className="section-header">
            <h2 id="comparison-title" className="section-title">Recruiting Agenturen im Vergleich: Warum Social Recruiting die Zukunft ist</h2>
            <p className="section-subtitle">
              Detaillierter Vergleich zwischen Social Recruiting Agenturen und traditionellen Recruiting-Methoden
            </p>
          </div>

          <div className="content-text">
            <p>
              Bei der Wahl der richtigen Recruiting-Strategie stehen Unternehmen in Berlin vor wichtigen Entscheidungen. Während traditionelle Recruiting Agenturen seit Jahren etabliert sind, bietet Social Recruiting innovative Ansätze, die besonders 2025 entscheidende Vorteile bringen. Unsere Social Recruiting Agentur kombiniert bewährte HR-Expertise mit modernsten Social Media Recruiting Techniken, um gezielt qualifizierte Bewerber zu finden und zu rekrutieren.
            </p>

            <h3>Wie Social Recruiting Agenturen Unternehmen in Berlin helfen, qualifizierte Mitarbeiter zu finden</h3>
            <p>
              Social Recruiting in Berlin hat sich als die effizienteste Methode etabliert, um offene Stellen mit den besten Talente zu besetzen. Der Recruiting Prozess wird durch den strategischen Einsatz von Social Media Plattformen wie LinkedIn, Instagram, Facebook und TikTok grundlegend optimiert. Unsere Social Recruiting Agentur nutzt gezielt diese Plattformen wie LinkedIn, um sowohl aktive als auch passive Kandidaten zu finden – ein entscheidender Vorteil gegenüber traditionellen Recruiting Maßnahmen.
            </p>

            {/* Team Section */}
            <div className="eb-team-section" style={{width: '100%', maxWidth: '1200px', margin: '4rem auto', padding: '3rem', background: 'linear-gradient(135deg, #a387c1 0%, #C9B1D3 100%)', borderRadius: '24px', boxShadow: '0 15px 50px rgba(163, 135, 193, 0.3)'}}>
              <h3 style={{textAlign: 'center', marginBottom: '1rem', color: 'white', fontSize: '2.5rem', fontWeight: 700}}>Unser Team von 15 Experten</h3>
              <p style={{textAlign: 'center', maxWidth: '800px', margin: '0 auto 3rem auto', fontSize: '1.125rem', color: 'rgba(255, 255, 255, 0.9)', lineHeight: 1.6}}>
                Strategen, Designer, HR-Spezialisten und Digital-Marketing-Profis – spezialisiert auf Mittelstand und Corporate-Unternehmen.
              </p>
              <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2.5rem', maxWidth: '1100px', margin: '0 auto'}}>
                {/* Team Member 1: Tobias */}
                <div style={{background: 'white', padding: '2.5rem', borderRadius: '20px', textAlign: 'center', boxShadow: '0 8px 30px rgba(0, 0, 0, 0.15)', transition: 'all 0.4s ease'}}>
                  <div style={{width: '180px', height: '180px', margin: '0 auto 1.5rem auto', borderRadius: '50%', overflow: 'hidden', border: '4px solid #a387c1', boxShadow: '0 8px 32px rgba(163, 135, 193, 0.4)', transition: 'all 0.4s ease'}}>
                    <img src="/images/tobias-team.png" alt="Tobias - CEO & Strategieexperte" style={{width: '100%', height: '100%', objectFit: 'cover'}} />
                  </div>
                  <h4 style={{fontSize: '1.75rem', fontWeight: 700, color: '#0D0D0D', marginBottom: '0.5rem'}}>Tobias</h4>
                  <p style={{fontSize: '1rem', color: '#a387c1', fontWeight: 600, marginBottom: '1rem'}}>CEO & Strategieexperte</p>
                  <p style={{color: '#6b7280', lineHeight: 1.7, fontSize: '1rem'}}>
                    Mastermind hinter unserem innovativen Recrutainment-Ansatz. Mit über 15 Jahren Erfahrung entwickelt Tobias maßgeschneiderte Social Recruiting Strategien für führende Unternehmen in Berlin und ganz Deutschland.
                  </p>
                </div>
                
                {/* Team Member 2: Jane */}
                <div style={{background: 'white', padding: '2.5rem', borderRadius: '20px', textAlign: 'center', boxShadow: '0 8px 30px rgba(0, 0, 0, 0.15)', transition: 'all 0.4s ease'}}>
                  <div style={{width: '180px', height: '180px', margin: '0 auto 1.5rem auto', borderRadius: '50%', overflow: 'hidden', border: '4px solid #bbd8a7', boxShadow: '0 8px 32px rgba(187, 216, 167, 0.4)', transition: 'all 0.4s ease'}}>
                    <img src="/images/jane-team.jpg" alt="Jane - Creative Director" style={{width: '100%', height: '100%', objectFit: 'cover'}} />
                  </div>
                  <h4 style={{fontSize: '1.75rem', fontWeight: 700, color: '#0D0D0D', marginBottom: '0.5rem'}}>Jane</h4>
                  <p style={{fontSize: '1rem', color: '#bbd8a7', fontWeight: 600, marginBottom: '1rem'}}>Creative Director</p>
                  <p style={{color: '#6b7280', lineHeight: 1.7, fontSize: '1rem'}}>
                    Verwandelt Employer Branding in authentische visuelle Geschichten. Jane kreiert überzeugende Recruiting-Kampagnen, die auf Instagram, LinkedIn und TikTok Begeisterung wecken und Top-Talente anziehen.
                  </p>
                </div>
                
                {/* Team Member 3: Marcel */}
                <div style={{background: 'white', padding: '2.5rem', borderRadius: '20px', textAlign: 'center', boxShadow: '0 8px 30px rgba(0, 0, 0, 0.15)', transition: 'all 0.4s ease'}}>
                  <div style={{width: '180px', height: '180px', margin: '0 auto 1.5rem auto', borderRadius: '50%', overflow: 'hidden', border: '4px solid #F8CBAD', boxShadow: '0 8px 32px rgba(248, 203, 173, 0.4)', transition: 'all 0.4s ease'}}>
                    <img src="/images/marcel-team.png" alt="Marcel - Performance Marketing Spezialist" style={{width: '100%', height: '100%', objectFit: 'cover'}} />
                  </div>
                  <h4 style={{fontSize: '1.75rem', fontWeight: 700, color: '#0D0D0D', marginBottom: '0.5rem'}}>Marcel</h4>
                  <p style={{fontSize: '1rem', color: '#F8CBAD', fontWeight: 600, marginBottom: '1rem'}}>Performance Marketing</p>
                  <p style={{color: '#6b7280', lineHeight: 1.7, fontSize: '1rem'}}>
                    Datengetriebene Kampagnenoptimierung für maximalen ROI. Marcel analysiert jeden Klick und optimiert kontinuierlich, um die besten Kandidaten bei minimalen Kosten pro Bewerbung zu erreichen.
                  </p>
                </div>
              </div>
            </div>

            <p>
              Der Erfolg einer Recruiting Kampagne hängt maßgeblich von der richtigen Ansprache der Zielgruppe ab. Durch maßgeschneiderte Social Media Recruiting Strategien erreichen wir potenzielle Kandidaten dort, wo sie ihre Zeit verbringen. Dies ermöglicht nicht nur eine effiziente Kontaktaufnahme, sondern auch den Aufbau einer starken Arbeitgebermarke. Beim Social Recruiting geht es nicht nur darum, offene Stellen zu besetzen, sondern Unternehmen als attraktiven Arbeitgeber zu positionieren.
            </p>

            <table className="comparison-table">
              <thead>
                <tr>
                  <th>Kriterium</th>
                  <th>Social Recruiting</th>
                  <th>Jobbörsen</th>
                  <th>Personalvermittler</th>
                  <th>Eigene Stellenanzeigen</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><strong>Kosten pro Bewerbung</strong></td>
                  <td>8-25€</td>
                  <td>500-1.500€/Monat</td>
                  <td>15-20% Jahresgehalt</td>
                  <td>Zeitaufwand + Streukosten</td>
                </tr>
                <tr>
                  <td><strong>Zeitrahmen</strong></td>
                  <td>7-14 Tage</td>
                  <td>3-8 Wochen</td>
                  <td>4-12 Wochen</td>
                  <td>6-12 Wochen</td>
                </tr>
                <tr>
                  <td><strong>Reichweite</strong></td>
                  <td>67% Social Media Nutzer</td>
                  <td>Nur aktiv Suchende (15-20%)</td>
                  <td>Eigenes Netzwerk</td>
                  <td>Begrenzt auf Website-Besucher</td>
                </tr>
                <tr>
                  <td><strong>Zielgruppe</strong></td>
                  <td>Aktive + Passive Talente</td>
                  <td>Nur aktiv Suchende</td>
                  <td>Meist aktiv Suchende</td>
                  <td>Nur aktiv Suchende</td>
                </tr>
                <tr className="highlight-row">
                  <td><strong>Employer Branding</strong></td>
                  <td><strong>Sehr hoch - Unternehmenskultur sichtbar</strong></td>
                  <td>Niedrig - Nur Stellenbeschreibung</td>
                  <td>Mittel - Abhängig vom Vermittler</td>
                  <td>Mittel - Begrenzte Reichweite</td>
                </tr>
                <tr>
                  <td><strong>Messbarkeit & Analytics</strong></td>
                  <td>Echtzeit-Daten, vollständig messbar</td>
                  <td>Begrenzte Statistiken</td>
                  <td>Keine Transparenz</td>
                  <td>Schwer zu tracken</td>
                </tr>
                <tr>
                  <td><strong>Skalierbarkeit</strong></td>
                  <td>Sehr gut - Kampagnen erweiterbar</td>
                  <td>Begrenzt - Neue Anzeigen nötig</td>
                  <td>Schlecht - Linear skalierbar</td>
                  <td>Schlecht - Ressourcenintensiv</td>
                </tr>
                <tr>
                  <td><strong>Qualität der Bewerber</strong></td>
                  <td>Sehr hoch durch gezieltes Targeting</td>
                  <td>Mittel - Breite Streuung</td>
                  <td>Hoch - Aber teuer</td>
                  <td>Variabel - Ungefiltert</td>
                </tr>
                <tr>
                  <td><strong>Recruiting Trends 2025</strong></td>
                  <td>Zukunftsorientiert, innovativ</td>
                  <td>Traditionell, wenig Innovation</td>
                  <td>Klassisch, statusquo</td>
                  <td>Veraltet, ineffizient</td>
                </tr>
              </tbody>
            </table>

            <p style={{marginTop: '2rem', fontSize: '0.95rem', color: '#6b7280'}}>
              <em>Quelle: famefact Datenanalyse basierend auf 500+ Recruiting Kampagnen in Berlin (2020-2025), Bundesagentur für Arbeit, Bitkom Recruiting-Studie 2025</em>
            </p>

            <h3>Recruiting und Employer Branding: Die Erfolgsformel unserer Social Recruiting Agentur</h3>
            <p>
              Der größte Vorteil von Social Recruiting liegt in der nahtlosen Verbindung von Recruiting und Employer Branding. Während traditionelle Recruiting Agenturen oft nur darauf fokussiert sind, Positionen schnell zu besetzen, verfolgt unsere Social Recruiting Agentur Berlin einen ganzheitlichen Ansatz.
            </p>

            <div className="success-box">
              <h4>Praxisbeispiel: Erfolg einer Recruiting Kampagne in Berlin 2025</h4>
              <p>
                Ein mittelständisches IT-Unternehmen in Berlin suchte 5 qualifizierte Softwareentwickler. Traditionelle Jobbörsen lieferten in 6 Wochen nur 3 unqualifizierte Bewerbungen bei Kosten von 3.000€. Unsere maßgeschneiderte Social Recruiting-Kampagne auf LinkedIn und Instagram generierte in nur 10 Tagen 18 qualifizierte Bewerbungen bei Gesamtkosten von 396€ (22€ pro Bewerbung).
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Platform Strategies */}
      <section className="content-section" aria-labelledby="platforms-title">
        <div className="container">
          <div className="section-header">
            <h2 id="platforms-title" className="section-title">Social Media Plattformen strategisch für Recruiting nutzen</h2>
            <p className="section-subtitle">
              Wie unsere Social Recruiting Agentur jede Plattform gezielt einsetzt
            </p>
          </div>

          <div className="feature-cards">
            <div className="feature-card">
              <div className="feature-card__icon">💼</div>
              <h4>LinkedIn: Professionelles Recruiting für qualifizierte Fachkräfte</h4>
              <p>
                LinkedIn ist die führende Plattform für B2B-Recruiting und die Ansprache von qualifizierten Fachkräften. Mit über 16 Millionen Nutzern im DACH-Raum bietet LinkedIn ideale Voraussetzungen für erfolgreiches Social Recruiting.
              </p>
            </div>

            <div className="feature-card">
              <div className="feature-card__icon">📸</div>
              <h4>Instagram: Employer Branding und junge Talente erreichen</h4>
              <p>
                Instagram eignet sich perfekt für Employer Branding und die Ansprache junger Talente in kreativen und innovativen Branchen. Mit visuellen Inhalten können Unternehmen ihre Unternehmenskultur authentisch präsentieren.
              </p>
            </div>

            <div className="feature-card">
              <div className="feature-card__icon">📱</div>
              <h4>TikTok: Gen Z Talente mit innovativen Recruiting</h4>
              <p>
                TikTok hat sich als die innovativste Plattform für Recruiting etabliert und erreicht besonders Gen Z-Talente. Mit kreativen Videos können Unternehmen viral gehen und enorme Reichweite erzielen.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq" aria-labelledby="faq-title">
        <div className="container">
          <div className="section-header">
            <h2 id="faq-title" className="section-title">Häufige Fragen zu Social Recruiting Berlin</h2>
            <p className="section-subtitle">Alles was Sie über Social Recruiting in Berlin wissen müssen</p>
          </div>
          <div className="faq__content">
            <div className="faq-item">
              <h4>Was kostet Social Recruiting in Berlin?</h4>
              <p>
                Bei famefact in Berlin liegen die Kosten zwischen 8-25€ pro qualifizierter Bewerbung – deutlich günstiger als Jobportale (500-1500€/Monat) oder Personalvermittler (20% Jahresgehalt).
              </p>
            </div>

            <div className="faq-item">
              <h4>Wie lange dauert es, bis erste Bewerbungen eintreffen?</h4>
              <p>
                In der Regel erhalten unsere Kunden in Berlin bereits nach 7-14 Tagen erste qualifizierte Bewerbungen über Social Media. Instagram und TikTok wirken besonders schnell bei jungen Zielgruppen, LinkedIn bei Fach- und Führungskräften.
              </p>
            </div>

            <div className="faq-item">
              <h4>Welche Branchen profitieren am meisten von Social Recruiting in Berlin?</h4>
              <p>
                Besonders erfolgreich ist Social Recruiting in Berlin für: IT & Tech, Logistik & Handel, Gastronomie, Start-ups und Handwerk. Alle Positionen profitieren von der großen Reichweite.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Facts Section */}
      <section className="facts" aria-labelledby="facts-title">
        <div className="container">
          <div className="section-header">
            <h2 id="facts-title" className="section-title">Social Recruiting Berlin: Zahlen & Fakten</h2>
            <p className="section-subtitle">Daten und Statistiken zu Social Recruiting in Berlin (Stand 2025)</p>
          </div>
          <div className="facts__grid">
            <div className="fact-card">
              <div className="fact-card__number">67%</div>
              <div className="fact-card__label">der Deutschen nutzen Social Media täglich</div>
              <div className="fact-card__source">Quelle: ARD/ZDF-Onlinestudie 2025</div>
            </div>
            <div className="fact-card">
              <div className="fact-card__number">8-25€</div>
              <div className="fact-card__label">durchschnittliche Kosten pro Bewerbung</div>
              <div className="fact-card__source">famefact Daten, Berlin 2025</div>
            </div>
            <div className="fact-card">
              <div className="fact-card__number">7-14 Tage</div>
              <div className="fact-card__label">bis zu ersten Bewerbungen</div>
              <div className="fact-card__source">Durchschnittliche Response-Zeit</div>
            </div>
            <div className="fact-card">
              <div className="fact-card__number">500+</div>
              <div className="fact-card__label">erfolgreiche Kampagnen</div>
              <div className="fact-card__source">seit 2009 in Berlin</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section with Patrick */}
      <section className="cta-section" style={{background: 'linear-gradient(135deg, #a387c1 0%, #C9B1D3 100%)', padding: '6rem 0'}}>
        <div className="container">
          <div style={{maxWidth: '1100px', margin: '0 auto'}}>
            <h2 className="cta-title" style={{color: 'white', textAlign: 'center', marginBottom: '1rem', fontSize: '2.5rem'}}>
              Bereit für erfolgreiches Social Recruiting in Berlin?
            </h2>
            <p className="cta-subtitle" style={{color: 'rgba(255, 255, 255, 0.9)', textAlign: 'center', fontSize: '1.25rem', marginBottom: '4rem', maxWidth: '700px', marginLeft: 'auto', marginRight: 'auto'}}>
              Vereinbaren Sie jetzt Ihr kostenloses Erstgespräch und erfahren Sie, wie Social Recruiting Ihr Unternehmen in Berlin voranbringt.
            </p>
            
            {/* Contact Card with Patrick */}
            <div style={{background: 'white', borderRadius: '24px', padding: '3rem', boxShadow: '0 20px 60px rgba(0, 0, 0, 0.2)', maxWidth: '800px', margin: '0 auto'}}>
              <div style={{display: 'grid', gridTemplateColumns: '200px 1fr', gap: '3rem', alignItems: 'center'}}>
                <div style={{width: '200px', height: '200px', borderRadius: '50%', overflow: 'hidden', border: '5px solid #a387c1', boxShadow: '0 12px 40px rgba(163, 135, 193, 0.4)'}}>
                  <img src="/images/patrick-b-team.webp" alt="Patrick Bergmann" style={{width: '100%', height: '100%', objectFit: 'cover'}} />
                </div>
                
                <div>
                  <p style={{color: '#a387c1', fontWeight: 600, fontSize: '0.95rem', marginBottom: '0.5rem', textTransform: 'uppercase', letterSpacing: '1px'}}>Ihr Ansprechpartner</p>
                  <h3 style={{color: '#0D0D0D', fontSize: '2rem', fontWeight: 700, marginBottom: '1.5rem'}}>Patrick Bergmann</h3>
                  
                  <div style={{display: 'flex', flexDirection: 'column', gap: '1rem', marginBottom: '2rem'}}>
                    <a href="mailto:patrick.bergmann@famefact.com" style={{display: 'flex', alignItems: 'center', gap: '0.75rem', color: '#6b7280', textDecoration: 'none', fontSize: '1.05rem'}}>
                      📧 <span style={{fontWeight: 500}}>patrick.bergmann@famefact.com</span>
                    </a>
                    
                    <a href="tel:+4930403665430" style={{display: 'flex', alignItems: 'center', gap: '0.75rem', color: '#6b7280', textDecoration: 'none', fontSize: '1.05rem'}}>
                      📞 <span style={{fontWeight: 500}}>030 403 665 430</span>
                    </a>
                  </div>
                  
                  <button className="btn btn--primary btn--large" data-open-consultation data-source="CTA Section Patrick" style={{width: '100%', background: 'linear-gradient(135deg, #a387c1 0%, #C9B1D3 100%)', border: 'none', padding: '1rem 2rem', fontSize: '1.125rem'}}>
                    Kostenloses Erstgespräch vereinbaren
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default HomePage;
